/* ==========================================================================
Swiper
https://swiperjs.com/
========================================================================== */

/* ==========================================================================
Card slider function
========================================================================== */
function swiperInit (swiperId) {
  const swiper = new Swiper('#testimonialsSlideshow', {
    slidesPerView: 1,
    spaceBetween: 20,
    freeMode: true,
    grabCursor: true,
    lazy: true,
    mousewheel: {
      forceToAxis: true
    },
    pagination: {
      el: ".testimonials-pagination",
      clickable: true
    },
    preloadImages: false,
    threshold: 10
  });
  return swiper;
}

/* ==========================================================================
Card slider initialize function if id exists
========================================================================== */
// Get all swiper instances with class 'custom-testimonials'
const swipers = document.querySelectorAll('.custom-testimonials');

// Check if there are swipers instances set on page
if (swipers.length) {
  // Loop through all swiper instances
  swipers.forEach(swiper => {
    // Get data attribute 'id'
    const swiperId = swiper.dataset.id;

    // Initialze function 'swiperInit' and pass on 'swiperId'
    swiperInit(swiperId);
  });
}

// console.log('swiper/card-slider.js is loading');
  